import { ModuleBase, Text, Stack } from '@/components';
import classNames from 'classnames';

import { SideBySideModuleModel } from './SideBySideModule';

const AboutUsPillars = (data: SideBySideModuleModel) => {
  const { title, description, cards } = data.props;

  return (
    <ModuleBase
      data={{ ...data, props: { ...data.props, backgroundColour: '#f1f0e9' } }}
      className="AboutUsPillars lg:half-bg-sand overflow-hidden"
      noPadding
    >
      <Stack className={classNames('relative')}>
        <div className="pointer-events-none left-0 w-full flex-col py-8 md:py-12 md:pr-5 lg:absolute lg:pr-20">
          <div className="container">
            <div className="xxl:gap-20 pointer-events-auto flex flex-col gap-5 lg:w-1/2 xl:gap-16">
              {title && (
                <Text
                  className="color-from-bg text-style-h3 pr-10 md:pr-20 lg:pr-0 xl:!text-[65px] xl:!leading-[70px]"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              )}

              <div className="color-from-bg relative flex w-fit flex-col">
                {description && <Text className="text-style-h4" dangerouslySetInnerHTML={{ __html: description }} />}
              </div>
            </div>
          </div>
        </div>

        <div className="container flex flex-col justify-end px-0 lg:flex-row">
          <div className="flex w-full flex-wrap bg-white lg:w-1/2">
            {cards &&
              cards.map((card, index) => (
                <div
                  key={index}
                  className={classNames(
                    ![0, 1].includes(index) && 'after-extended-line-top',
                    'flex w-1/2 items-center border-black px-5 py-8 odd:border-r sm:px-9 md:py-12 lg:px-10',
                  )}
                >
                  <span className="text-style-h5">{card.title}</span>
                </div>
              ))}
          </div>
        </div>
      </Stack>
    </ModuleBase>
  );
};

export default AboutUsPillars;
